"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("./index171.js");var e=t.getBuiltIn,l=e("document","documentElement");exports.html=l;
